import React from "react"
import PropTypes from "prop-types"
import {Link, withRouter} from 'react-router-dom';
import {Button, Col, FormControl, FormGroup, Glyphicon, InputGroup, Row} from "react-bootstrap"
import {TableHeaderColumn} from "react-bootstrap-table"
import BaseGrid from "../BaseGrid"
import FormButtons from "../form/FormButtons"
import {Acl, Grid} from "../../utils"

class Users extends BaseGrid {

	constructor(props) {
		super(props);

		this.state = {
			...this.state,
			action: null,
			actionModalOpen: null,
			actionItems: []
		};

		this.handleActionSelect = this.handleActionSelect.bind(this);
		this.handleActionSubmit = this.handleActionSubmit.bind(this);
		this.handleRowSelect = this.handleRowSelect.bind(this);
		this.handleRowSelectAll = this.handleRowSelectAll.bind(this);

		this.handleActionModalDismiss = this.handleActionModalDismiss.bind(this)
	}

	getDefaultFilter() {
		return {
			"statuses": "ACTIVE",
			"roleIds": null,

			"search": "",
			"orderCol": "lastName",
			"orderDir": "a",
			"start": 0,
			"rows": this.getDefaultPageRows()
		}
	}

	handleRowSelect({userId}, isSelected) {
		const {actionItems} = this.state;
		if (isSelected) {
			this.setState({
				actionItems: [...actionItems, userId].sort()
			});
		} else {
			this.setState({actionItems: actionItems.filter(it => it !== userId)});
		}
		return false;
	}

	handleRowSelectAll(isSelected) {
		const {items, session} = this.props;
		if (!isSelected) {
			this.setState({actionItems: []})
		} else {
			const actionItems = [];
			for (let i = 0; i < items.length; i++) {
				if (!Acl.isAllowed(session, Acl.right.ADMIN) && items[i].userId) {
					continue
				}
				actionItems.push(items[i].userId)
			}
			this.setState({actionItems: actionItems})
		}
	}

	handleActionSelect(action) {
		this.setState({action: action})
	}

	handleActionSubmit() {
		const {actionItems, action} = this.state;
		if (!actionItems || !actionItems.length || !action || !action.value) {
			return
		}

		if ("archive" === action.value) {
			this.props.onShowModal(
				'Hromadné ukončení činnosti',
				'Skutečně hromadně ukončit činnost vybraných členů (' + actionItems.length + ')?',
				{style: 'danger', label: 'Hromadně ukončit činnost', icon: 'trash'},
				() => this.props.onUpdateUserStatus("deleted", actionItems).then((json) => {
					if (json && json.response && json.response.result === 'OK') {
						this.onFilterChange()
					} else {
						return new Promise((resolve, reject) => reject())
					}
				})
			)

		} else {
			this.setState({actionModalOpen: true})
		}
	}

	handleActionModalDismiss() {
		this.setState({actionModalOpen: false})
	}

	renderActionModal() {
		// const {session} = this.props;
		const {actionModalOpen, actionItems} = this.state;
		if (!actionModalOpen) {
			return null
		}
		const {items} = this.props;
		const selected = [];
		if (items && items.length) {
			for (let i = 0; i < items.length; i++) {
				if (actionItems.indexOf(items[i].userId) >= 0) {
					selected.push(items[i])
				}
			}
		}
	}

	formatStatus(cell, row) {
		switch (cell) {
			case "ACTIVE":
				return "Aktivní";
			case "DELETED":
				return "Smazaný";
			default:
				return cell
		}
	}

	formatEmail(cell, row) {
		return <Link to={{pathname: "/uzivatele/" + row.userId}}>{cell}</Link>
	}

	formatName(cell, row) {
		return row.firstName ? row.firstName + ' ' + row.lastName : row.lastName
	}

	formatActions(cell, row) {
		return <span>
			<Link to={{pathname: "/uzivatele/" + row.userId}} className="btn">detail</Link>
			&nbsp;
			<Link to={{pathname: "/uzivatele/" + row.userId + "/uprava"}} className="btn">upravit</Link>
		</span>
	}

	formatRow(row, index) {
		return (row && row.status === 'DELETED' ? "alert-muted" : null)
	}

	getFilter() {
		const {filter} = this.state;
		// const {enums} = this.props;

		const statuses = [
			{value: 'ACTIVE', label: 'Aktivní'},
			{value: 'DELETED', label: 'Smazaný'}
		];

		return [
			<Row key="1">
				<Col xs={6}>
					<FormGroup>
						<InputGroup>
							<FormControl type="text" value={filter.search} name="search" placeholder="Příjmení, email" onChange={this.handleInputChange}/>
							<div className="input-group-btn">
								{filter.search ? <span className={"btn-clear-text"} onClick={this.onFilterReset}>×</span> : null}
								<Button type="submit" bsStyle="info">
									<Glyphicon glyph="search"/> <span className={"hidden-sm hidden-xs"}>Vyhledat</span></Button>
							</div>
						</InputGroup>
					</FormGroup>
				</Col>
				{/*<Col xs={2}>*/}
				{/*{Grid.renderSelect("roleIds", "(všechny role)", filter.roleIds, Enums.createEnumItems(enums, "role"), this.handleSelectChange)}*/}
				{/*</Col>*/}
				<Col xs={6}>
					<Row>
						<Col xs={7}>
							<FormButtons currentValue={filter.statuses} options={statuses} name="statuses" onInputChange={this.handleInputChange}/>
						</Col>
						{Grid.renderFilterButtons(this.onFilterReset, 5)}
					</Row>
				</Col>
			</Row>];
	}

	getCols() {
		return [
			<TableHeaderColumn key="0" dataField="userId" width='10%' dataAlign="center" dataSort={true}>#</TableHeaderColumn>,
			<TableHeaderColumn key="1" dataField="email" width='40%' dataAlign="center" dataFormat={this.formatEmail} dataSort={true}>Email</TableHeaderColumn>,
			<TableHeaderColumn key="2" dataField="lastName" width='30%' dataSort={true} dataFormat={this.formatName}>Jméno</TableHeaderColumn>,
			<TableHeaderColumn key="3" dataField="status" width='10%' dataAlign="center" dataFormat={this.formatStatus}>Stav</TableHeaderColumn>,
			<TableHeaderColumn key="4" dataField="userId" width='10%' dataAlign="center" dataFormat={this.formatActions}>&nbsp;</TableHeaderColumn>
		]
	}

	render() {
		const {isFetchingItems, items, count, filter, session} = this.props;

		const actions = null;
		// if (Acl.isAllowed(session, Acl.right.USER_EDIT_LIMITED)) {
		// 	actions.push({
		// 		value: "archive",
		// 		label: 'Hromadně archivovat'
		// 	})
		// }

		const actionCtx = {
			onActionSelect: this.handleActionSelect,
			onActionSubmit: this.handleActionSubmit,
			value: this.state.action,
			key: 'userId',
			selectRowProp: {
				mode: 'checkbox',
				clickToSelect: true,
				onSelect: this.handleRowSelect,
				onSelectAll: this.handleRowSelectAll,
				selected: this.state.actionItems,
				bgColor: function (row, isSelect) {
					if (isSelect) {
						return "#fcf8e3"
					}
					return null;
				},
				unselectable: []
			},
			actions: actions
		};

		if (items && !Acl.isAllowed(session, Acl.right.ADMIN)) {
			for (let i = 0; i < items.length; i++) {
				if (items[i].userId) {
					actionCtx.selectRowProp.unselectable.push(items[i].userId)
				}
			}
		}

		return <div>{Grid.renderFull(isFetchingItems, items, count,
			Grid.getTableOptions(filter, this.onPageChange, this.onSortChange, this.onFilterChange, this.renderPaginationShowsTotal),
			this.getCols(),
			this.getFilter(),
			this.onFilterChange,
			actionCtx, this.formatRow)}
			{this.renderActionModal()}
		</div>
	}
}


Users.propTypes = {
	onFetchEnums: PropTypes.func.isRequired,
	enums: PropTypes.object.isRequired,
	onShowModal: PropTypes.func.isRequired,
	onUpdateUserStatus: PropTypes.func,
	onShowMessage: PropTypes.func.isRequired
};

export default withRouter(Users)



// WEBPACK FOOTER //
// ./src/components/user/Users.js